import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useRouteMatch } from 'react-router';

const CompanyDetailsPage = () => {
  const history = useHistory();
  const match = useRouteMatch();

  const { companyId } = match.params;

  useEffect(() => {
    if (match.isExact) {
      history.push(`/app/registry/companies/${companyId}/general`);
    }
  }, [match.isExact]);

  return null;
};

CompanyDetailsPage.propTypes = {
  route: PropTypes.object.isRequired,
};

export default CompanyDetailsPage;
